import { Accordion, Button, FixedFooter, Modal } from "@components/";
import { useOrder } from "./useOrder";
import { useRef, useState } from "react";
import { useParams } from "react-router-dom";

export function Order() {
  const pageRef = useRef<HTMLDivElement>(null);
  const { sideConversationId } = useParams<{ sideConversationId: string }>();
  const { navigate, orderData, isLoading, error, deleteProduct } = useOrder();
  
  const [modalOpen, setModalOpen] = useState(false);
  const [productToDelete, setProductToDelete] = useState<string | null>(null);

  const handleConfirmDelete = () => {
    if (productToDelete) {
      deleteProduct(productToDelete);
      setModalOpen(false);
      setProductToDelete(null);
    }
  };

  const handleCancelDelete = () => {
    setModalOpen(false);
    setProductToDelete(null);
  };

  return (
    <div ref={pageRef} className="h-full flex flex-col gap-2 py-[22.5px] px-4">
      <h1 className="text-[18px] font-semibold">
        Pedido
        <span className="text-[#87929D]">• #{sideConversationId || "..."}</span>
      </h1>

      {isLoading && (
        <div className="mb-auto mt-auto flex items-center justify-center">
          <h4 className="text-center text-[14px] text-[#87929D] font-reg">
            Carregando dados do pedido...
          </h4>
        </div>
      )}
      {error && !isLoading && (
        <div className="mb-auto mt-auto flex items-center justify-center">
          <h4 className="text-center text-[14px] text-red-500 font-reg">
            {error}
          </h4>
        </div>
      )}

      {!isLoading && !error && orderData && (
        <>
          <div className="mb-4">
            <Accordion
              title={orderData.title}
              fields={orderData.sideConversationFields}
              values={orderData.sideConversationValues}
              defaultOpen={true}
            />
          </div>

          {orderData.products.length > 0 ? (
            <>
              <h3 className="text-[14px] font-medium text-[#87929D] mb-2">
                Total de produtos: {orderData.products.length}
              </h3>

              {orderData.products.map((product, index) => (
                <div key={product.id} className="mb-4">
                  <Accordion
                    title={`Produto ${index + 1}`}
                    fields={[
                      "Nome",
                      "Código do produto",
                      "Marca",
                      "Linha",
                      "Família do produto",
                      "Código ERP",
                      "Ativo",
                      "Peso",
                      "Altura",
                      "Largura",
                      "Profundidade",
                      "Quantidade",
                      "Preço",
                    ]}
                    values={[
                      product.produtoComercial || "-",
                      product.codigo || "-",
                      product.marca || "-",
                      product.linha || "-",
                      product.familiaProduto || "-",
                      product.codigoErp || "-",
                      product.ativo || "-",
                      product.peso || "-",
                      product.altura || "-",
                      product.largura || "-",
                      product.profundidade || "-",
                      product.quantidade || "-",
                      product.preco || "-",
                    ]}
                    defaultOpen={index === 0}
                  >
                    <div className="p-4 flex gap-2 border-t border-gray-200">
                      <Button
                        size="medium"
                        variant="outline-danger"
                        onClick={() => {
                          setProductToDelete(product.id);
                          setModalOpen(true);
                        }}
                      >
                        Remover
                      </Button>
                    </div>
                  </Accordion>
                </div>
              ))}
            </>
          ) : (
            <div className="mb-auto mt-auto flex flex-col items-center justify-center gap-2">
              <h4 className="text-center text-[14px] text-[#87929D] font-reg">
                Nenhum produto encontrado para este pedido
              </h4>
            </div>
          )}
        </>
      )}

      {/* No order data */}
      {!isLoading && !error && !orderData && (
        <div className="mb-auto mt-auto flex flex-col items-center justify-center gap-2">
          <h4 className="text-center text-[14px] text-[#87929D] font-reg">
            Pedido não encontrado
          </h4>
        </div>
      )}

      <FixedFooter pageRef={pageRef}>
        <Button
          variant="outline"
          onClick={() => {
            navigate(`/new-product?sideConversationId=${sideConversationId}`);
          }}
        >
          Adicionar produto
        </Button>
        <Button
          variant="outline"
          onClick={() => {
            navigate("/");
          }}
        >
          Voltar
        </Button>
      </FixedFooter>

      {/* Modal de confirmação para deletar produto */}
      <Modal
        isOpen={modalOpen}
        onClose={handleCancelDelete}
        onConfirm={handleConfirmDelete}
        title="Tem certeza?"
        variant="danger"
        confirmText="Confirmar"
        cancelText="Cancelar"
      >
        Tem certeza de que deseja deletar este <strong>produto</strong>?
      </Modal>
    </div>
  );
}
